import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Asset, AssetTypeName } from '@app/_models/_DTOs/asset';
import { AssetHistoryActionType } from '@app/_models/assetHistoryActionType';
import { AssetType } from '@app/_models/enums/assetType';
import { AssetHistoryActionName, AssetHistory } from '@app/_models/_DTOs/assetHistory';
import { environment } from '@environments/environment';
import { Media } from '@app/_models/_DTOs/media';
import { AssetService } from '@app/_services';
import { DocumentService } from '@app/_services/document.service';
import { NzMessageService } from 'ng-zorro-antd';
import { ResizeService } from '@app/_services/resize.service';
import { SCREEN_SIZE } from '@app/_helpers/screen-size.enum';
import { AssetHistoryDocumentStatus } from '@app/_models/enums/assetHistoryDocumentStatus';
import { Employee } from '@app/_models/_DTOs/employee';
import { Subject } from 'rxjs';
import { ITuple } from '@app/_models/tuple';
import { LocationService } from '@app/_services/location.service';
import { EmployeeService } from '@app/_services/employee.service';
import { Location } from '@app/_models/_DTOs/location';

@Component({
  selector: 'app-asset-details',
  templateUrl: './asset-details.component.html',
  styleUrls: ['./asset-details.component.css']
})
export class AssetDetailsComponent implements OnInit {

  @Input() level: number;
  selectedAsset: Asset;
  isOpen: boolean = false;

  @Output() drawerClosed = new EventEmitter();

  drawerWidth: string = "calc(60vw - 256px)";
  order: string = '-logTime';

  public assetHistoryActionType = AssetHistoryActionType;
  public assetHistoryDocumentStatus = AssetHistoryDocumentStatus;
  public assetTypes = AssetType;

  apiUrl: string;
  previewImage: string | undefined = '';
  previewVisible = false;

  selectedEmployee: Employee;
  selectedEmployeeAssetsSubject: Subject<ITuple<Asset>> = new Subject<ITuple<Asset>>();

  selectedLocation: Location;
  selectedLocationAssetsSubject: Subject<ITuple<Asset>> = new Subject<ITuple<Asset>>();

  constructor(private assetService: AssetService,
    private documentService: DocumentService,
    private messageService: NzMessageService,
    private locationService: LocationService,
    private employeeService: EmployeeService,
    private resizeService: ResizeService) {
    this.apiUrl = environment.apiUrl;

    this.resizeService.onResize$.subscribe(size => {
      this.drawerWidth = this.resizeService.getWideDrawerWidth();
    });

  }

  loadAsset(assetId: number) {
    this.isOpen = true;
    this.assetService
      .get(assetId)
      .subscribe((data: Asset) => {
        this.selectedAsset = data;
      });
  }

  ngOnInit() {
    if (this.resizeService.currentSize != null) {
      this.drawerWidth = this.resizeService.getWideDrawerWidth();
    }
  }

  closeDetails() {
    this.selectedAsset = null;
    this.isOpen = false;
    this.drawerClosed.emit();
  }

  previewMedia(media: Media) {
    this.previewImage = `${this.apiUrl}/files/${media.path}`;
    this.previewVisible = true;
  }

  getPdf(assetHistoryAction: AssetHistory) {
    var document = assetHistoryAction.documents.sort((val1, val2) => { return new Date(val2.created).getTime() - new Date(val1.created).getTime() })[0];
    this.documentService.getPdf(document.id).subscribe((result: any) => {
      if (result.type == 'application/pdf') {
        var blob = new Blob([result], { type: "application/pdf" });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
        }
        else {
          var fileUrl = URL.createObjectURL(blob);
          window.open(fileUrl, '_blank');
        }
      }
      else {
        this.messageService.create("error", "Dokument nije pronađen.");
      }
    }
    );
  }

  // (assetHistory.actionType == AssetHistoryActionType.AssignToEmployee && 
  //   assetHistory.newEmployee.id == asset.employee.id &&
  //   assetHistory.documents.length == 0) ||
  // (assetHistory.actionType == AssetHistoryActionType.AssignToLocation && )

  public getActionTypeName(actionType: AssetHistoryActionType) {
    return AssetHistoryActionName.get(actionType).name;
  }

  public getAssetTypeName(assetType: any) {
    return AssetTypeName.get(assetType);
  }

  public assetTypeKeys() {
    var keys = Object.keys(this.assetTypes);
    return keys.slice(keys.length / 2);
  }

  dateComparator(date1: string, date2: string) {
    return new Date(date1).getTime() >= new Date(date2).getTime() ? 1 : -1;
  }

  getDate(dateString: string) {
    return new Date(dateString);
  }

  openEmployeeDetails(employee: Employee) {
    this.employeeService
      .get(employee.id)
      .subscribe((data: Employee) => {
        this.selectedEmployee = data;
        this.assetService.getPage(1, 10, "-Created", `(EmployeeId|Location.PersonInChargeId)==${employee.id}`)
          .subscribe((data: ITuple<Asset>) => {
            this.selectedEmployeeAssetsSubject.next(data);
          });
      });
  }

  openLocationDetails(location: Location) {
    this.locationService
      .get(location.id)
      .subscribe((data: Location) => {
        this.selectedLocation = data;
        this.assetService.getPage(1, 10, "-Created", `LocationId==${location.id}`)
          .subscribe((data: ITuple<Asset>) => {
            this.selectedLocationAssetsSubject.next(data);
          });
      })
  }

  closeEmployeeDetails() {
    this.selectedEmployee = null;
  }

  closeLocationDetails() {
    this.selectedLocation = null;
  }

}
